export default __webpack_public_path__ + "static/media/arrow-back.7f46da79.svg";